import { CSSProperties, ReactNode } from 'react';

export const inputTableBorder = '1px solid rgba(224, 224, 224, 1)';

export type ColumnFilterType = 'search' | 'filter' | null;

export interface UpHeaderColumn {
  id: string | number;
  title?: string;
  colSpan?: number;
  centered?: boolean;
  style?: CSSProperties;
}

export interface SelectableTableColumn {
  id: string;
  title: string;
  type: 'text' | 'radio' | 'checkbox' | 'switch' | 'date' | 'children' | 'link' | 'actions';
  filterType: ColumnFilterType;
  sortable?: boolean;
  centered?: boolean;
  width?: string;
  skipEnterMethod?: boolean;
  style?: CSSProperties;
}

export type IndexedStrings = { [key: string]: string | string[] };

export type SelectableTablePossibleCellsType = string | number | boolean | Date | JSX.Element | ReactNode;

export interface CellWithColSpan {
  colSpan: number;
  data: ReactNode;
}

export const isCellWithColSpan = (value: SelectableTablePossibleCellsType) => {
  return value !== null && value !== undefined && typeof value === 'object' && 'colSpan' in value;
};

export interface TableSelection {
  items: string[];
  isAll?: boolean;
}

export type ForceSelectionCallback = (selection: TableSelection) => void;
